import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  flexShrink: 0,
  whiteSpace: 'nowrap',
};
